<template>
  <section
    class="component-cdfa9ab3"
    resmed-component-name="card_3col_icon-line_graphic_text_cta"
    v-bind:style="styles"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container text-center" v-if="acf.headline">
        <div v-if="acf.eyebrowicon" class="pt-5">
          <eyebrow-icon
            v-bind:eyebrowicon="acf.eyebrowicon"
            v-bind:align="'center'"
          ></eyebrow-icon>
        </div>
        <div class="mb-3">
          <h2 v-html="acf.headline"></h2>
          <div class="px-lg-6">
            <p v-if="acf.description" v-html="acf.description"></p>
          </div>
        </div>
      </div>

      <div style="overflow: hidden">
        <div class="swiper container">
          <div class="row">
            <div class="col" style="padding: 0">
              <div class="seek">
                <!-- items.length > 3 -->
                <template>
                  <div class="seek-wrapper" v-show="sliderControlsVisible">
                    <a
                      ref="swiperButtonPrev"
                      href="#"
                      class="btn navigation-icon left-caret swiper-button-prev"
                    ></a>
                    <a
                      ref="swiperButtonNext"
                      href="#"
                      class="btn navigation-icon right-caret swiper-button-next"
                    ></a>
                  </div>
                </template>

                <div
                  ref="swiperContainer"
                  class="swiper-container"
                  v-bind:class="`-mode-${[$root.mode]}`"
                >
                  <div class="items swiper-wrapper">
                    <div
                      class="item swiper-slide mb-3 mb-lg-0 text-center"
                      v-for="(item, index) in acf.items"
                    >
                      <div class="wrapper">
                        <!-- <eyebrow-icon
                          v-if="item.eyebrowicon"
                          v-bind:eyebrowicon="item.eyebrowicon"
                        ></eyebrow-icon> -->
                        <div class="product-img">
                          <img
                            class="
                            img-fluid
                            mx-auto
                            img-top
                            my-auto
                            product-featured-img
                          "
                            v-bind:src="`${item.image}`"
                            alt=""
                          />
                        </div>
                        <div class="card-body pr-xs-4 pr-lg-0 pt-4">
                          <h4 class="title card-title" v-html="item.title"></h4>
                          <div
                            v-if="item.description"
                            class="description"
                            v-html="item.description"
                          ></div>

                          <div
                            v-if="item.cta.href"
                            class="mt-3 cta d-flex justify-content-center align-items-baseline"
                            style="gap: 6px;"
                          >
                            <a
                              v-bind:href="item.cta.href"
                              v-bind:target="item.cta.target"
                              class="btn cta-plain text-red icon p-0 textButtonDark"
                              >{{ item.cta.text }}</a
                            >
                            <img
                              src="@/assets/images/icon-right-arrow-black.svg"
                              style="height:0.6rem; width: 0.6rem;"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-show="sliderControlsVisible">
            <div class="col">
              <div ref="swiperPagination" class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helper from "../../mixins/swiper-helper";
import fieldStateUsVue from "../forms/fields/field-state-us.vue";

export default {
  name: "component-cdfa9ab3", // card_3col_icon-line_graphic_text_cta
  props: ["acf"],
  data() {
    return {
      initialized: false,
      slider: undefined,
      styles: {
        "background-color": this.acf.layout["background-color"],
      },
      // notShow: !($cookies.get("b2bFirstName")),
    };
  },
  mixins: [helper],
  watch: {
    "$root.mode": {
      handler(val) {
        this.styles = Object.assign({}, this.styles, {
          "padding-top": "3rem",
          "padding-bottom": "3rem",
        });

        this.$set(
          this.styles,
          "background-image",
          `url(${this.acf.layout["background-image"]})`
        );

        if (
          ["xs", "sm"].includes(val) &&
          this.acf.layout["background-image-xs"]
        ) {
          this.$set(
            this.styles,
            "background-image",
            `url(${this.acf.layout["background-image-xs"]})`
          );
        }

        if (["md", "lg", "xl"].includes(val)) {
          this.styles = Object.assign({}, this.styles, {
            "padding-top": this.acf.layout["padding-top"],
            "padding-bottom": this.acf.layout["padding-bottom"],
          });
        } else {
          this.styles = Object.assign({}, this.styles, {
            "padding-top": "0",
            "padding-bottom": "0",
          });
        }
      },
      immediate: true,
    },
    shouldUseSlider(v) {
      if (this.initialized) {
        if (v) {
          this.swhReload();
        } else {
          this.swhDestroy();
        }
      }
    },
  },
  computed: {
    notShow() {
      const role = $cookies.get("role");
      const categoryCookie = $cookies.get("categories");

      try {
        if (
          (categoryCookie == "" || categoryCookie == null) &&
          (role != "" || role != null)
        ) {
          this.$cookies.set(
            "categories",
            role && role.replace(/approved/g, "approve"),
            null,
            "/",
            window.location.hostname.includes(".resmed.com")
              ? ".resmed.com"
              : "localhost"
          );
        }
      } catch (error) {
        console.log(error);
      }
      const b2bFirstName = $cookies.get("b2bFirstName");

      if (
        (!b2bFirstName && !role) ||
        (b2bFirstName && role && !role.includes("technical_approved"))
      ) {
        return true;
      }
      return false;
    },
    sliderControlsVisible() {
      return this.shouldUseSlider && this.acf.items.length > 3;
    },
    shouldUseSlider() {
      return !["xs", "sm"].includes(this.$root.mode);
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.shouldUseSlider) {
        this.swhReload();
      }

      this.initialized = true;
    });
  },
  methods: {
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        // loop: true,
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-cdfa9ab3 {
  padding: 3rem 0;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
}

h2 {
  position: relative;
  margin-bottom: 1rem;
  color: $cc-resmed-white;

  @extend %eyebrow-center;
  &:before {
    background-color: $cc-resmed-white;
  }
}

h4 {
  position: relative;
  margin-bottom: 0.625rem;
  font-family: "Plus Jakarta Sans", Arial, sans-serif;
}

.product-img {
  height: 200px;

  .product-featured-img {
    max-height: 140px;
  }
}

@media only screen and (min-device-width: 767px) and (max-device-width: 1023px) {
  .product-img {
    height: 140px;
    .product-featured-img {
      max-height: 120px;
    }
  }
}

@media (max-width: 767px) {
  .product-img {
    height: 200px;

    .product-featured-img {
      max-height: 140px;
    }
  }
}

.swiper {
  padding: 0 3.5rem;

  @media (min-width: 768px) {
    padding: 0;
    padding-left: 10px;
    padding-right: 10px;
  }
  @media (max-width: 768px) {
    padding: 0;
  }
}

.seek-wrapper {
  position: absolute;
  z-index: 1;

  width: 30%;
  bottom: -42px;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: 992px) {
    width: 20%;
  }

  @media (min-width: 768px) and (max-width: 991px) {
    width: 100%;
    bottom: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  @media (min-width: 1306px) {
    width: 100%;
    bottom: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  a:nth-child(1) {
    float: left;
    transform: translateX(-3rem) scale(1.175);

    @media (min-width: 992px) {
      transform: translateX(-4rem) scale(1.4);
    }
  }

  a:nth-child(2) {
    float: right;
    transform: translateX(3rem) scale(1.175);

    @media (min-width: 992px) {
      transform: translateX(4rem) scale(1.4);
    }
  }
}

.-mode-xs,
.-mode-sm {
  &.swiper-container {
    overflow: visible;
  }
}

.-mode-md,
.-mode-lg,
.-mode-xl {
  &.swiper-container {
    overflow: hidden;
  }
}

.swiper-container {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;

  margin: 0 auto;
  padding: 1rem 0 0.5rem 0;

  @media (max-width: 768px) {
    padding: 0;
  }
}

.items {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;

  @media (min-width: 768px) {
    display: flex;
    align-items: stretch;
    justify-content: center;
  }
}

.item {
  padding: 0 0.625rem;
  display: flex;
  flex-shrink: 0;
  align-items: stretch;

  .wrapper {
    flex-grow: 1;
    padding: 2rem;
    position: relative;
    // box-shadow: -1px 0.25rem 12px 2px rgba(0, 0, 0, 0.125);
    border-radius: 6px;
    background-color: $cc-resmed-white;
    // min-height: 31.25rem;
    @media (max-width: 768px) {
      border-radius: 0;
    }
    // @media (min-width: 768px) and (max-width: 991.98px) {
    //   min-height: 21.25rem;
    // }

    h4,
    > h4 + div {
      color: $cc-resmed-black;
    }
    .product-featured-img {
      max-width: 296px;
    }
  }
  .card-body {
    // position: absolute;
    bottom: 2rem;
  }
  .card-body {
    .description {
      font-family: "Plus Jakarta Sans", Arial, sans-serif;
      // min-height: 132px;
      // padding-right: 2rem;
    }
    .title,
    .cta {
      // padding-right: 2rem;
    }
    .card-title {
      font-size: 1.25rem; // 20px for desktop
      line-height: 1.5;
      font-weight: 500;
      
      @media (max-width: 767px) {
        font-size: 1rem; // 16px for mobile
      }
    }
  }
}

/* ----------- iPad Pro ----------- */
/* Landscape*/

@media only screen and (min-device-width: 1366px) and (max-device-height: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .product-featured-img {
    max-width: 225px !important;
  }
  .item {
    .wrapper {
      // min-height: 23.25rem;
      .card-body {
        position: relative;
        .description {
          padding-right: 0;
        }
      }
    }
  }
}

/* Portrait*/
@media only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
  .product-featured-img {
    max-width: 225px !important;
  }
  .item {
    .wrapper {
      // min-height: 23.25rem;
      .card-body {
        position: relative;
        .description {
          padding-right: 0;
        }
      }
    }
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1023px) and (-webkit-min-device-pixel-ratio: 1) {
  .product-featured-img {
    max-width: 150px !important;
  }
  .item {
    .wrapper {
      // min-height: 23.25rem;
      .card-body {
        position: relative;
        .description {
          padding-right: 0;
        }
      }
    }
  }
}
</style>
